import React, { Component } from 'react'
import homepageBg from '../assets/images/homepage-bg.svg'
import { ArticlesTable } from '../components/ArticlesTable'

class Dashboard extends Component {
    render() {
        return (
            <div>
                <div className="header-bg-container">
                    <div
                        style={{
                            backgroundImage: `url(${homepageBg})`,
                        }}
                        className={'homepage-bg-svg'}
                    />
                </div>
                <h1 className={'content-title'}>
                    Welcome to the article portal
                </h1>
                <ArticlesTable />
            </div>
        )
    }
}

export default Dashboard
